import { ContactEmail } from '@base/common/Contact';
import styles from '@pro/help/default.module.less';

export default function WrongItemReceived() {
    return (
        <div className={styles.help}>
            <h1>Wrong Item Received</h1>
            <p>If we&apos;ve sent you something you didn&apos;t order, we want to get the correct item to you as fast as possible.</p>
            <p><strong>To get started:</strong></p>
            <ul>
                <li>1) Email us at <ContactEmail/> with your order number</li>
                <li>2) Send us the pictures of the wrong product you received, include all labels that stick on the shipping box</li>
                <li>3) Pick your preferred solution (refund or replacement)</li>
                <li>4) We&apos;ll provide return instructions</li>
            </ul>
            <p>Be sure to complete this process within <strong>30 days</strong> of the delivery date.</p>
        </div>
    )
};